// extracted by mini-css-extract-plugin
export default {"container":"Lk-z","blurb":"Mk-z","links":"Nk-z"};